class SearchFilter {
    button: Element;
    filter: Element;

    constructor(button: Element, filter: Element) {
        this.button = button;
        this.filter = filter;

        const urlParams = new URLSearchParams(window.location.search);

        if (
            (urlParams.has('types') && urlParams.get('types') !== '') ||
            (urlParams.has('trackids') && urlParams.get('trackids') !== '') ||
            (urlParams.has('parentformatids') && urlParams.get('parentformatids') !== '')
        ) {
            this.filter.classList.toggle('hidden');
            this.button.querySelector('svg')?.classList.toggle('rotate-45');
        }

        this.button.addEventListener('click', () => {
            this.filter.classList.toggle('hidden');
            this.button.querySelector('svg')?.classList.toggle('rotate-45');
        });
    }
}

export default {
    init() {
        const searchFilterButton = document.querySelector('.search-filter-button');
        const searchFilter = document.querySelector('.search-filter');

        if (!searchFilter || !searchFilterButton) {
            return;
        }

        new SearchFilter(searchFilterButton, searchFilter);
    }
};
